import { Tier, TierHierarchy } from '@mc/api'
import { ANNUAL_PASS, DUO, FAMILY, INDIVIDUAL } from '../constants'
import { getTiersAsync, ProductsQueryParams } from './getTiersAsync'

export type PlanName =
  | typeof INDIVIDUAL
  | typeof DUO
  | typeof FAMILY
  | typeof ANNUAL_PASS
  | 'Standard'
  | 'Plus'
  | 'Premium'

let specificTier: Tier

const mapHierarchy = (planName?: PlanName) => {
  if (planName === DUO || planName === 'Plus') {
    return TierHierarchy.DUO
  }
  if (planName === FAMILY || planName === 'Premium') {
    return TierHierarchy.FAMILY
  }

  return TierHierarchy.INDIVIDUAL
}

export const getSpecificTierPropertiesAsync = async (
  planName?: PlanName,
  refresh = false,
  params: ProductsQueryParams = {},
) => {
  const hierarchy = mapHierarchy(planName)

  if (!!specificTier && !refresh && specificTier.hierarchy === hierarchy) {
    return Promise.resolve(specificTier)
  }

  const pricingTiers = await getTiersAsync(params)
  specificTier =
    pricingTiers.find((tier) => tier.hierarchy === hierarchy) || ({} as Tier)

  return specificTier
}
